.brand-logo {
  height: auto;
  width: 100%;
  cursor: pointer;
}
